var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#0072b2;}.cls-3{fill:#71c2ea;}.cls-4{fill:#00a0df;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.48,
    y: 0.62,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "log_out"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.53,249.29h19v102h-19a51,51,0,1,1,0-102Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.46,300.27a81.1,81.1,0,0,0,81.07,80.93h19V516.56a20,20,0,0,1-20,20H22.86a20,20,0,0,1-20-20V86.63a20,20,0,0,1,20-20H366.55a20,20,0,0,1,20,20V219.34h-19A81.1,81.1,0,0,0,286.46,300.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.55,599.64,1.86,537.28V66.67L225.4,3.28a33.9,33.9,0,0,1,43.18,32.56V567A33.9,33.9,0,0,1,225.55,599.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 200.86,
    cy: 301.6,
    rx: 40.61,
    ry: 40.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M588.05,323.13l-107,94.42a31.25,31.25,0,0,1-20.87,8c-16.39,0-32-12.82-32-31.79V351.25H367.53a51,51,0,1,1,0-102h60.72V205c0-19,15.58-31.78,32-31.78a31.28,31.28,0,0,1,20.87,8l107,94.42A31.68,31.68,0,0,1,588.05,323.13Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ce731316ca77c3b390cbd45ad71be3a1.svg";
export { ForwardRef as ReactComponent };